export var Access;
(function (Access) {
    Access["ADMIN"] = "admin";
    Access["DEFAULT"] = "default";
})(Access || (Access = {}));
